import { fa } from "element-plus/es/locale";
import { Ref, ref } from "vue";

export const usePageConfig = (): Ref<PaginationConfigType> => {
  const page:Ref<PaginationConfigType> = ref({
    page: 1,
    limit: 10,
    total: 0,
  });
  return page;
}

export const useTableOptions = (listName='表格数据', {showPageBar=true,isShowHeader=true,loading=false, ...otherConfig}= {}, ) => {
  const options = ref({
    listName,
    showPageBar,
    isShowHeader,
    loading,
    ...otherConfig,
  })
  return options;
}


export const useDialogConfig = (title="弹框", visible=false, { isShowFooter=true, isShowConfirm=true, ...otherConfig }= {}) => {
  const options = ref({
    title,
    isShowFooter,
    visible,
    isShowConfirm,
    ...otherConfig,
  })
  return options;
}